export default {
  week: {
    page: 1,
    feed: [],
  },
  month: {
    page: 1,
    feed: [],
  },
  sixMonths: {
    page: 1,
    feed: [],
  },
  year: {
    page: 1,
    feed: [],
  },
  allTime: {
    page: 1,
    feed: [],
  },
};



// WEBPACK FOOTER //
// ./src/lib/initialState.js